import { render, staticRenderFns } from "./AddAdditionalCharges.vue?vue&type=template&id=760c71ee&scoped=true&"
import script from "./AddAdditionalCharges.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalCharges.vue?vue&type=script&lang=js&"
import style0 from "./AddAdditionalCharges.vue?vue&type=style&index=0&id=760c71ee&scoped=true&lang=css&"
import style1 from "./AddAdditionalCharges.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c71ee",
  null
  
)

export default component.exports